import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Text } from "sunrise-ui";
import { Doughnut } from "react-chartjs-2";
import "./Projects.scss";

const ProjectStatus = (props: any) => {
  const { totalPileLength, completedPileLength } = props;
  const [workOrderLeft, setWorkOrderLeft] = useState(0);
  useEffect(() => {
    setWorkOrderLeft(Number(totalPileLength - completedPileLength));
  }, [totalPileLength, completedPileLength]);

  return (
    <Grid item lg={2} xs={3}>
      <Grid className="box--shadow project_info_card p1 mr-1 h15">
        <Text
          type="normal"
          fonts="normal"
          fontSize={16}
          className="mb0 mt0 fw500"
        >
          Project Status
        </Text>
        <Grid className="d-flex h-center v-center mb relative">
          <Grid className="doughnut_box">
            <Doughnut
              data={{
                datasets: [
                  {
                    label: "# project status",
                    data: [completedPileLength, workOrderLeft],
                    backgroundColor: ["#5F67E0", "#DDDDDD"],
                  },
                ],
              }}
            />
            {/* <span>70%</span> */}
            <Text
              type="normal"
              fonts="normal"
              fontSize={13}
              className={`mb0 mt0 fw500 absolute ${
                completedPileLength ? "doughnut_text" : ""
              }`}
            >
              {`${
                completedPileLength && totalPileLength
                  ? Math.round((completedPileLength / totalPileLength) * 100)
                  : 0
              }%`}
            </Text>
          </Grid>
        </Grid>
        <Grid>
          <Text
            type="normal"
            fonts="normal"
            fontSize={13}
            className="mb1 mt0 fw500 "
          >
            Total Piles To Be Filled
            <br />
            (mts): <span className="fw400">{totalPileLength}</span>
          </Text>
          <Text
            type="normal"
            fonts="normal"
            fontSize={13}
            className="mb mt0 fw400 text--primary"
          >
            <span
              className="iconify text--primary mr vm"
              data-icon="akar-icons:circle-fill"
            ></span>
            {totalPileLength ? totalPileLength : 0} mts
          </Text>
          <Text
            type="normal"
            fonts="normal"
            fontSize={13}
            className="mb0 mt0 fw400 text--secondry"
          >
            <span
              className="iconify dot_icon_secondary mr vm"
              data-icon="akar-icons:circle-fill"
            ></span>
            {completedPileLength ? completedPileLength : 0} mts
          </Text>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProjectStatus;
